import {useContext} from 'react';
import {Route, Routes} from 'react-router-dom';
import About from './about';
import Practice from './practice';
import Navbar from './navbar';
import SignIn from './signin';
import Payment from './payment';
import withAuth from './auth';
import { ProfileProvider } from './contexts/profileContext';
import { ErrorContext } from './contexts/errorContext';
function App() {
  const {error} = useContext(ErrorContext);

  function RouteWithAuth({component, ...rest}) {
    const WrappedComponent = withAuth(component);
    return <WrappedComponent/>
  }
 
  return (
    <ProfileProvider>
      {error && <div className='fixed z-50 bg-red-200 text-red-800 p-5 text-center' style={{width: 'calc(100vw - (100vw - 100%))'}}>{error}</div>}
      <Navbar/>
      <Routes>
        <Route path="/" element={<About/>} />
        <Route path="/signin" element={<SignIn/>} />
        {/* <Route path="/practice" element={<Practice/>} /> */}
        <Route path="/practice" element={<Practice/>}/>
        <Route path="/payment" element={<Payment/>} />
      </Routes>
    </ProfileProvider>
    
  );
}

export default App;
